import { cva } from 'class-variance-authority';

/** Un solo primario por vista; secundarios con borde; destructivos con confirmación (docs/DISENO.md §9). */
export const buttonVariants = cva(
  [
    'inline-flex shrink-0 select-none items-center justify-center gap-2 whitespace-nowrap rounded-md font-semibold',
    'transition-[background-color,border-color,color,box-shadow,transform] duration-fast ease-standard',
    'active:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none',
  ],
  {
    variants: {
      variant: {
        primary: 'bg-primary text-primary-fg shadow-elev-1 hover:bg-primary-strong',
        secondary:
          'border border-border bg-card text-fg shadow-elev-1 hover:border-input hover:bg-muted',
        ghost: 'text-fg hover:bg-muted',
        danger: 'bg-down text-primary-fg shadow-elev-1 hover:brightness-95',
        link: 'h-auto min-h-0 px-0 text-primary underline underline-offset-4 hover:text-primary-strong',
      },
      size: {
        sm: 'h-9 px-3 text-sm [@media(pointer:coarse)]:h-11',
        md: 'h-11 px-4 text-base',
        lg: 'h-12 px-6 text-base',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
);
